
import React from 'react';
import {FIRST_NAME, LAST_NAME, EMAIL, ACCOUNT_NUMBERS, NUM_ACCT} from "../SA_UserPortfolios/prm";
import {Text} from "../../../lib/prm/text";
import {Name} from "../../../lib/prm/name";
import {FlowRender} from "../../../lib/flow-render";
import {Action, DashboardContainer, Spinner} from "../../funcs/utils";
import {DashboardTable} from "../dashboard-table";
import {LPOADialog} from "./LPOA-dialog";
import {EnvelopeStatus, ProxyDocumentDelivery} from "../../../lib/docusign-constants";
import {deep_copy} from "../../../lib/js-utils";
import {adminCreateUser, updateLPOAItem} from "../SA_UserPortfolios/actions";
import {sprintf} from "sprintf-js";

const PHONE_NUMBER = new Text(new Name("PHONE_NUMBER"));

const ALL_PRMS = new FlowRender(0, [
  FIRST_NAME, LAST_NAME, EMAIL, ...ACCOUNT_NUMBERS, PHONE_NUMBER, NUM_ACCT
]);

const STYLE_LUT = (num_items) => {
  return [
    // Vertical lines
    {
      pred: () => true,
      style: {
        borderLeft: "solid 1px black",
        borderRight: "solid 1px black",
        paddingLeft: "0.3rem",
      }
    },
    // Header top/bottom borders
    {
      pred: (row) => row === 0,
      style: {
        borderTop: "solid 1px black",
        borderBottom: "solid 1px black",
        backgroundColor: "#EEE",
      }
    },
    // Bottom row
    {
      pred: (row) => row === num_items,
      style: {
        borderBottom: "solid 1px black",
      }
    },
  ];
}

const dump_menu = (component, item) => {
  const buttons = [
    { id: "action", label: "" },
    { id: "advisor", label: "Proxy Onboarding - Advisor"},
    { id: "user", label: "Proxy Onboarding - User"},
  ];

  const lpoa_inactive = (component, account_number) => {
    updateLPOAItem(component.props.token, account_number)
      .then(result => {
        if (result.status === "OK") {
          const items = deep_copy(component.state.lpoa_items);
          for (let i = 0; i < items.length; i++) {
            if (items[i].account_number === account_number) {
              items[i] = result.payload;
            }
          }
          component.setState({lpoa_items: items});
        } else {
          console.log("Error", result);
        }
      })
  }

  const on_change = ev => {
    const action = ev.target.value;

    if (action === "advisor") {
      component.setState({
        lpoa_creating_user: true,
      })

      adminCreateUser(
        component.props.token,
        item.role_0_first_name,
        item.role_0_last_name,
        component.props.wlf_id,
        item.role_0_email,
        item.account_number,
        ProxyDocumentDelivery.NO_ENVELOPE,
        {
          role_0_phone_number: item.role_0_phone_number,
          LPOA_envelope_id: item.envelope_id,
        })
        .then(result => {
          if (!result.success) {
            component.setState({
              new_user_error: result.message,
              lpoa_creating_user: false,
            })
          } else {
            console.log("CreateUser result", result);
            component.setState({
              lpoa_creating_user: false,
            });
            component.doLoadProxyOnboarding();
            lpoa_inactive(component, item.account_number);

            // Navigate to onboarding
            const args = {
              username: result.username,
              identity_id: result.identity_id,
              account_state: result.account_state,
              acct_index: sprintf("%d", result.account_index),
            }
            const url = sprintf(
              "/wlf-admin/onboarding_%04d/personal_info", result.account_index);
            component.props.navigatePath(url, args);
          }

        }
      )
    } else if (action === "user") {
      console.log("user");
    }

  }

  return (
    <select
      value={""}
      onChange={on_change}>
      { buttons.map(button => {
        return (<option key={button.id} value={button.id}>{button.label}</option>);
      })}
    </select>);
}

const dump_table = component => {
  const items = component.state.lpoa_items;
  const data = [
    [ "Name", "Email", "Account Number", "State", "Action" ],
  ];
  items.forEach(item => {
    let state = "";
    const has_acct = !!item.username;
    if (has_acct) {
      state = "account generated";
    } else if (item.envelope_status === EnvelopeStatus.SENT) {
      state = "OUT FOR SIGNATURE";
    } else if (item.envelope_status === EnvelopeStatus.COMPLETED) {
      state = "SIGNED";
    }
    data.push([
      item.role_0_first_name + " " + item.role_0_last_name,
      item.role_0_email,
      item.id,
      state,
      has_acct ? "" : dump_menu(component, item),
    ])
  })
  const table_style = {
    width: "100%",
  }
  return (
    <DashboardTable
      data={data}
      tdStyleLut={STYLE_LUT(items.length)}
      tableStyle={table_style}/>
  )
}

const LPOADashboard = props => {

  const component = props.component;

  const on_click = () => {
    component.setState({
      show_lpoa_dialog: true,
    })
  }

  const spinner = component.state.loading_lpoa ? (
    <div align={"center"} style={{paddingTop: "2rem"}} >
      <Spinner size={"3rem"}/>
    </div>
  ) : null;

  const create_button = (
    <div style={{display: "flex", width: "100%"}}>
      <div style={{flex: "1"}}/>
      <div>
        <Action onClick={on_click}>
          Create New LPOA
        </Action>
      </div>
    </div>);
  const prms = { FIRST_NAME, LAST_NAME, EMAIL, PHONE_NUMBER, ACCOUNT_NUMBERS, NUM_ACCT };
  const dialog = component.state.show_lpoa_dialog
    ? (<LPOADialog
      prms={prms}
      component={component}/>) : null;

  return (
    <DashboardContainer
      client={props.client}
      spinner={component.state.lpoa_creating_user}
      header={create_button}
      title={"LPOA Signings"}>
      { dump_table(component) }
      { spinner }
      { dialog }
    </DashboardContainer>);
}


const init_lpoa = (component) => {
  const new_state = {
    show_lpoa_dialog: false,
    highlight_rects: [],
    creating_lpoa: false,
    lpoa_creating_user: false,
    loading_lpoa: false,
    lpoa_items: [],
    lpoa_error: "",
  }
  ALL_PRMS.init(new_state, {}, component);
  component.lpoa_dialog_ref = React.createRef();
  return new_state;
}

export { init_lpoa, LPOADashboard };
